import React, { useEffect, useRef } from "react";

// SASS
import "./Part8.scss";

// COMPONENTS
import Step from "../Step/Step";

// HELPERS
import animate from "../../utils/animate";

// LIBRARIES
import scrollama from "scrollama";

// ASSETS
import educatorImg from "../../assets/img/Educator.png";
import whiteboardImg from "../../assets/img/Whiteboard.png";
import audienceImg from "../../assets/img/Audience.png";
import coughImg from "../../assets/img/Cough2.png";
import tearImg from "../../assets/img/Large-Tear.png";
import germImg from "../../assets/img/germ.svg";
import faceShieldImg from "../../assets/img/Orange-Face-Shield.png";
import greenEyewearImg from "../../assets/img/Green-eyewear.png";

export default function Part8({ step }) {
  // SCROLLAMA INSTANCE
  const scrolly = scrollama();

  // ANIMATION STEP DATA
  const animationSequence = [
    { stepNumber: "0", height: null, description: "spacer" },
    // {
    //   stepNumber: "1",
    //   height: null,
    //   description: "add class show to animate--1",
    // },
    // { stepNumber: "2", height: null, description: "show reveal--2" },
    {
      stepNumber: "3",
      height: null,
      description: "hide hide--2, show reveal--1",
    },
    {
      stepNumber: "3a",
      height: null,
      description: "show reveal--1a",
    },
    {
      stepNumber: "3b",
      height: null,
      description: "show reveal--1b",
    },
    {
      stepNumber: "3c",
      height: null,
      description: "how reveal--1c",
    },
    {
      stepNumber: "4",
      height: null,
      description: "hide hide--1, show reveal--3",
    },
    {
      stepNumber: "5",
      height: null,
      description: "hide hide--3, show reveal--4",
    },
    { stepNumber: "6", height: null, description: "spacer" },
  ];

  // REFS
  const animate1Ref = useRef(null);
  const reveal1Ref = useRef(null);
  const reveal1aRef = useRef(null);
  const reveal1bRef = useRef(null);
  const reveal1cRef = useRef(null);
  const reveal2Ref = useRef(null);
  const hide1Ref = useRef(null);
  const hide2Ref = useRef(null);
  const reveal3Ref = useRef(null);
  const hide3Ref = useRef(null);
  const reveal4Ref = useRef(null);

  // RUN WHEN THE COMPONENT MOUNTS
  useEffect(() => {
    scrolly
      .setup({
        step: `.${step}`,
        debug: false,
        threshold: 1,
        progress: true,
      })
      .onStepEnter(({ element, direction }) => {
        const step = element.dataset.step;
        switch (step) {
          // case "1": {
          //   animate.addClassOnEnter(animate1Ref.current, "show", direction);
          //   break;
          // }
          // case "2": {


          //   break;
          // }
          case "3": {
            animate.addClassOnEnter(animate1Ref.current, "show", direction);
            animate.fadeOutOnEnter(hide2Ref.current, direction);
            animate.fadeInOnEnter(reveal1Ref.current, direction);
            break;
          }
          case "3a": {
            animate.fadeInOnEnter(reveal1aRef.current, direction);
            break;
          }
          case "3b": {
            animate.fadeInOnEnter(reveal1bRef.current, direction);
            break;
          }
          case "3c": {
            animate.fadeInOnEnter(reveal2Ref.current, direction);
            animate.fadeInOnEnter(reveal1cRef.current, direction);
            break;
          }
          case "4": {
            animate.fadeOutOnEnter(hide1Ref.current, direction);
            animate.fadeInOnEnter(reveal3Ref.current, direction);
            break;
          }
          case "5": {
            animate.fadeOutOnEnter(hide3Ref.current, direction);
            animate.fadeInOnEnter(reveal4Ref.current, direction);
            break;
          }
          default:
            break;
        }
      })
      .onStepProgress(({ element, progress }) => {
        const step = element.dataset.step;
        switch (step) {
          default:
            break;
        }
      })
      .onStepExit(({ element, direction }) => {
        const step = element.dataset.step;
        switch (step) {
          // case "1": {
          //   animate.removeClassOnExit(animate1Ref.current, "show", direction);
          //   break;
          // }
          // case "2": {


          //   break;
          // }
          case "3": {
            animate.removeClassOnExit(animate1Ref.current, "show", direction);
            animate.fadeInOnExit(hide2Ref.current, direction);
            animate.fadeOutOnExit(reveal1Ref.current, direction);
            break;
          }
          case "3a": {
            animate.fadeOutOnExit(reveal1aRef.current, direction);
            break;
          }
          case "3b": {
            animate.fadeOutOnExit(reveal1bRef.current, direction);
            break;
          }
          case "3c": {
            animate.fadeOutOnExit(reveal1cRef.current, direction);
            animate.fadeOutOnExit(reveal2Ref.current, direction);
            break;
          }
          case "4": {
            animate.fadeInOnExit(hide1Ref.current, direction);
            animate.fadeOutOnExit(reveal3Ref.current, direction);
            break;
          }
          case "5": {
            animate.fadeInOnExit(hide3Ref.current, direction);
            animate.fadeOutOnExit(reveal4Ref.current, direction);
            break;
          }
          default:
            break;
        }
      });
  }, [scrolly, step]);

  // CUSTOM FUNCTIONS

  return (
    <section className="wrapper">
      <div className="sticky-container">
        {/* STICKY */}
        <div className="part8">
          <div className="presentation">
            <div className="presentation__whiteboard-wrapper">
              <div className="presentation__whiteboard">
                <img src={whiteboardImg} alt="" className="img-fluid" />
                <div className="presentation__speaker">
                  <img src={educatorImg} alt="" className="img-fluid" />
                </div>
                <div className="presentation__text-container">
                  {/* INSERT CONTENT HERE */}
                  <div className="scene scene--1 hide hide--1" ref={hide1Ref}>
                    <div className="text-box">
                      <div className="text text--1 hide hide--2" ref={hide2Ref}>
                        Similarly, when germs land in your eyes through
                        respiratory droplets, they can:
                      </div>
                      <div
                        className="text text--2 reveal reveal--1"
                        ref={reveal1Ref}
                      >
                        Mix with the liquid in your eyes <br />
                        <span className="reveal reveal--1a" ref={reveal1aRef}>
                          Travel down your tear ducts <br />
                        </span>
                        <span className="reveal reveal--1b" ref={reveal1bRef}>
                          Drain into your nose and throat <br />
                        </span>
                        <span className="reveal reveal--1c" ref={reveal1cRef}>
                          Make you sick <br />
                        </span>
                      </div>
                    </div>
                    <div className="cough">
                      <img src={coughImg} alt="" className="img-fluid" />
                    </div>
                    <div className="drops animate animate--1" ref={animate1Ref}>
                      <div className="drop drop--1">
                        <img src={tearImg} alt="" className="img-fluid" />
                      </div>
                      <div className="drop drop--2">
                        {" "}
                        <img src={tearImg} alt="" className="img-fluid" />
                      </div>
                      <div className="drop drop--3">
                        {" "}
                        <img src={tearImg} alt="" className="img-fluid" />
                      </div>
                      <div className="drop drop--4">
                        {" "}
                        <img src={tearImg} alt="" className="img-fluid" />
                      </div>
                      <div className="drop drop--5">
                        {" "}
                        <img src={tearImg} alt="" className="img-fluid" />
                      </div>
                    </div>
                    <div
                      className="germ rotate reveal reveal--2"
                      ref={reveal2Ref}
                    >
                      <img src={germImg} alt="" className="img-fluid" />
                    </div>
                  </div>
                  <div
                    className="scene scene--2 reveal reveal--3"
                    ref={reveal3Ref}
                  >
                    <div className="text-box">
                      <div className="text text--1 hide hide--3" ref={hide3Ref}>
                        Your tears do a great job of protecting your eye most of
                        the time, but you can help them with an extra layer of
                        protection in the form of your{" "}
                        <span className="green">goggles</span> or{" "}
                        <span className="orange">face shields</span>.
                      </div>
                      <div
                        className="text text--2 reveal reveal--4"
                        ref={reveal4Ref}
                      >
                        Just make sure that your <br />
                        <span className="blue">
                          PPE doesn’t block your vision!
                        </span>
                      </div>
                    </div>
                    <div className="faceshield">
                      <img src={faceShieldImg} alt="" className="img-fluid" />
                    </div>
                    <div className="goggles">
                      <img src={greenEyewearImg} alt="" className="img-fluid" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="presentation__audience-wrapper">
              <div className="presentation__audience">
                <img src={audienceImg} alt="" className="img-fluid" />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* STEPS */}
      {animationSequence.map(({ stepNumber, height, description, offset }) => {
        return (
          <Step
            stepSection={step}
            stepNumber={stepNumber}
            stepDescription={description}
            height={height}
            key={stepNumber}
            offset={offset}
          />
        );
      })}
    </section>
  );
}
